import { Checkbox } from "@/components/ui/checkbox";
import { eur, slugifyId } from "@/lib/format";

export const initialSelection = (options) =>
  Object.fromEntries(options.map((o) => {
    const defs = o.values.filter((v) => v.default).map((v) => v.value);
    return [o.name, o.kind === "checkbox" ? defs : defs[0] || ""];
  }));

export const selectedValues = (options, sel) =>
  options.flatMap((o) => {
    const chosen = o.kind === "checkbox" ? sel[o.name] || [] : [sel[o.name]];
    return o.values.filter((v) => chosen.includes(v.value)).map((v) => ({ name: o.name, value: v.value, markup: v.markup }));
  });

export const OptionPicker = ({ option: o, sel, setSel }) => {
  const id = slugifyId(o.name);
  if (o.kind === "checkbox") {
    const cur = sel[o.name] || [];
    const toggle = (val) => setSel({ ...sel, [o.name]: cur.includes(val) ? cur.filter((x) => x !== val) : [...cur, val] });
    return (
      <div data-testid={`option-${id}`}>
        <p className="mb-3 text-sm font-semibold text-slate-900">{o.name}</p>
        <div className="space-y-2">
          {o.values.map((v) => (
            <label key={v.value} className="flex cursor-pointer items-center gap-3 rounded-xl border border-slate-200 px-4 py-3 text-sm text-slate-800 transition-colors hover:border-[#0066FF]/50">
              <Checkbox checked={cur.includes(v.value)} onCheckedChange={() => toggle(v.value)} data-testid={`option-${id}-${slugifyId(v.value)}`} />
              <span className="flex-1">{v.value}</span>
              {v.markup > 0 && <span className="font-mono text-xs font-medium text-[#0066FF]">+{eur(v.markup)}</span>}
            </label>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div data-testid={`option-${id}`}>
      <p className="mb-3 text-sm font-semibold text-slate-900">{o.name}{o.required && <span className="text-[#0066FF]"> *</span>}
        {sel[o.name] && <span className="ml-2 font-normal text-slate-500">{sel[o.name]}</span>}</p>
      <div className="flex flex-wrap gap-2">
        {o.values.map((v) => {
          const on = sel[o.name] === v.value;
          return (
            <button key={v.value} onClick={() => setSel({ ...sel, [o.name]: on && !o.required ? "" : v.value })} data-testid={`option-${id}-${slugifyId(v.value)}`}
              className={`rounded-full border px-4 py-2 text-sm transition-colors ${on ? "border-[#0066FF] bg-[#0066FF] text-white" : "border-slate-300 text-slate-700 hover:border-[#0066FF] hover:text-[#0066FF]"}`}>
              {v.swatch && <span className="mr-2 inline-block h-3 w-3 rounded-full align-middle ring-1 ring-slate-300" style={{ background: v.swatch }} />}
              {v.value}{v.markup > 0 && <span className={`ml-1.5 font-mono text-[11px] ${on ? "text-white/85" : "text-[#0066FF]"}`}>+{eur(v.markup)}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};
